module.exports = __webpack_public_path__ + "/images/ico-preview.364504d.svg";